export default "__VITE_ASSET__DOinGzBu__"